"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var setCredentials = require('./setCredentials');
var API_ENDPOINT = process.env.REACT_APP_GOOGLE_OAUTH_API_ENDPOINT || process.env.NEXT_PUBLIC_GOOGLE_OAUTH_API_ENDPOINT;
var ENDPOINTS = {
  getAuthorizationUrl: 'get-google-auth-url',
  getGoogleAuthTokens: 'get-google-auth-tokens',
  refreshGoogleAuthToken: 'refresh-google-auth-token',
  revokeGoogleRefreshToken: 'revoke-refresh-token'
};
var getAuthorizationUrl = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return fetch("".concat(API_ENDPOINT, "/").concat(ENDPOINTS.getAuthorizationUrl)).then(function (res) {
            return res.json();
          });
        case 1:
          response = _context.sent;
          return _context.abrupt("return", _objectSpread({
            error: false
          }, response));
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          return _context.abrupt("return", {
            error: true,
            message: _t.message
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function getAuthorizationUrl() {
    return _ref.apply(this, arguments);
  };
}();
var getGoogleAuthTokens = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(authorizationCode) {
    var _yield$fetch$then, credentials, _t2;
    return _regenerator["default"].wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 1;
          return fetch("".concat(API_ENDPOINT, "/").concat(ENDPOINTS.getGoogleAuthTokens), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              authorizationCode: authorizationCode
            })
          }).then(function (res) {
            return res.json();
          });
        case 1:
          _yield$fetch$then = _context2.sent;
          credentials = _yield$fetch$then.credentials;
          setCredentials.google(credentials);
          return _context2.abrupt("return", {
            credentials: credentials,
            error: false,
            message: 'success'
          });
        case 2:
          _context2.prev = 2;
          _t2 = _context2["catch"](0);
          return _context2.abrupt("return", {
            error: true,
            message: _t2.message
          });
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return function getGoogleAuthTokens(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var refreshGoogleAuthToken = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var _t3;
    return _regenerator["default"].wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 1;
          return fetch("".concat(API_ENDPOINT, "/").concat(ENDPOINTS.refreshGoogleAuthToken), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            credentials: 'include',
            mode: 'no-cors'
          });
        case 1:
          return _context3.abrupt("return", {
            error: false,
            message: 'success'
          });
        case 2:
          _context3.prev = 2;
          _t3 = _context3["catch"](0);
          return _context3.abrupt("return", {
            error: true,
            message: _t3.message
          });
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 2]]);
  }));
  return function refreshGoogleAuthToken() {
    return _ref3.apply(this, arguments);
  };
}();
var revokeRefreshGoogleAuthToken = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var _t4;
    return _regenerator["default"].wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 1;
          return fetch("".concat(API_ENDPOINT, "/").concat(ENDPOINTS.revokeGoogleRefreshToken), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            credentials: 'include',
            mode: 'no-cors'
          });
        case 1:
          return _context4.abrupt("return", {
            error: false,
            message: 'success'
          });
        case 2:
          _context4.prev = 2;
          _t4 = _context4["catch"](0);
          return _context4.abrupt("return", {
            error: true,
            message: _t4.message
          });
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 2]]);
  }));
  return function revokeRefreshGoogleAuthToken() {
    return _ref4.apply(this, arguments);
  };
}();
var _default = exports["default"] = {
  getAuthorizationUrl: getAuthorizationUrl,
  getGoogleAuthTokens: getGoogleAuthTokens,
  refreshGoogleAuthToken: refreshGoogleAuthToken,
  revokeRefreshGoogleAuthToken: revokeRefreshGoogleAuthToken
};